import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 22,
	viewBox: "0 0 22 22",
	width: 22,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m1 11h3.75" }),
			/* @__PURE__ */ _jsx("path", { d: "m11 4.75v-3.75" }),
			/* @__PURE__ */ _jsx("path", { d: "m11 17.25c3.4518 0 6.25-2.7982 6.25-6.25 0-3.45178-2.7982-6.25-6.25-6.25-3.45178 0-6.25 2.79822-6.25 6.25 0 3.4518 2.79822 6.25 6.25 6.25z" }),
			/* @__PURE__ */ _jsx("path", { d: "m11 21v-3.75" }),
			/* @__PURE__ */ _jsx("path", { d: "m17.25 11h3.75" }),
			/* @__PURE__ */ _jsx("path", { d: "m11 11h.05" })
		]
	})
});
export default SvgLocationSmall;
